/**
 * Feature gates read from the build-time env. Kept out of env.ts so tests that mock env.ts
 * with a partial object still get a working (off-by-default) answer here.
 */
import { env } from "./env";

/** Whether the MCP Servers section (#939) is on in this build (REACT_APP_MCP_SERVERS_ENABLED). */
export function isMcpServersEnabled(): boolean {
  return env.REACT_APP_MCP_SERVERS_ENABLED === "true";
}
